import React from 'react';

export interface ErrorMessageProps {
  type: 'network' | 'api' | 'validation';
  message: string;
  onRetry?: () => void;
  retryText?: string;
  className?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  type,
  message,
  onRetry,
  retryText = 'Retry',
  className = '',
}) => {
  const getErrorStyles = () => {
    switch (type) {
      case 'network':
        return {
          backgroundColor: '#ffebee',
          border: '1px solid #f44336',
          color: '#d32f2f',
        };
      case 'api':
        return {
          backgroundColor: '#fff3e0',
          border: '1px solid #ff9800',
          color: '#e65100',
        };
      case 'validation':
        return {
          backgroundColor: '#f3e5f5',
          border: '1px solid #9c27b0',
          color: '#6a1b9a',
        };
      default:
        return {
          backgroundColor: '#ffebee',
          border: '1px solid #f44336',
          color: '#d32f2f',
        };
    }
  };

  const getButtonStyles = () => {
    switch (type) {
      case 'network':
        return {
          backgroundColor: '#f44336',
          color: 'white',
        };
      case 'api':
        return {
          backgroundColor: '#ff9800',
          color: 'white',
        };
      case 'validation':
        return {
          backgroundColor: '#9c27b0',
          color: 'white',
        };
      default:
        return {
          backgroundColor: '#f44336',
          color: 'white',
        };
    }
  };

  return (
    <div
      className={`error-message ${className}`}
      style={{
        ...getErrorStyles(),
        borderRadius: '4px',
        padding: '12px',
        marginTop: '16px',
        textAlign: 'center',
      }}
    >
      <p style={{ margin: '0 0 8px 0' }}>{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            ...getButtonStyles(),
            border: 'none',
            padding: '8px 16px',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          {retryText}
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;
